/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react';
import { NavBar, List, Popup, Button } from 'antd-mobile';
import { CloseOutline } from 'antd-mobile-icons';
import moment from 'moment';
import get from 'lodash/get';
import styled from 'styled-components';
import InputComponent from './Input';
import { getCustomFields, getTrackingParameters, isEnabledParameter } from '../utils/helpers';
import { OBJECT_TYPE_AIRCRAFT_DEFECT, SQL_DATE_FORMAT } from '../utils/constants';
import CustomFieldInputItem from './CustomFieldsInput';
import UserSelfContext from '../utils/self-context';

const DefectWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;
const ContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow: auto;
	width: 100%;
	background: #f0f2f5;
`;

const Overview = styled.div`
	padding: 12px 0px;
`;

const Nav = styled(NavBar)`
	background: #fff;
	display: flex;
	border-bottom: solid 1px var(--adm-color-border);
`;

const Save = styled(Button)`
	font-size: 17px;
`;

function DefectPopup(props) {
	const {
		defect = {},
		visible,
		saving,
		onClose,
		aircraft = {},
		onSave
	} = props;
	const { userSelf } = useContext(UserSelfContext);

	const TRACKING_PARAMETERS = getTrackingParameters(userSelf);

	const [values, setValues] = useState({
		date: moment().format(SQL_DATE_FORMAT),
		...defect
	});

	function onSaveClick() {
		onSave(values);
	}

	useEffect(() => {
		setValues({
			date: moment().format(SQL_DATE_FORMAT),
			...defect
		});
	}, [visible]);

	async function onValueChange(data) {
		setValues({ ...values, ...data });
	}

	return (
		<Popup
			position='right'
			visible={visible}
			bodyStyle={{ width: '100%' }}
			onClose={onClose}
		>
			<DefectWrapper>
				<Nav
					backArrow={<CloseOutline />}
					onBack={onClose}
					back={''}
					right={<Save fill='none' loading={saving} onClick={onSaveClick}>Save</Save>}
				>
					Add defect
				</Nav>
				<ContentWrapper>
					<Overview>
						<List>
							<InputComponent
								onSave={onValueChange}
								dataKey="type"
								title="Type"
								requiredRulesObjectType={OBJECT_TYPE_AIRCRAFT_DEFECT}
								type="select"
								options={(get(userSelf, 'settings.defect_types') || []).map(t => ({ label: t, value: t }))}
								initialValue={[values.type]}
							/>
							<InputComponent
								placeholder="Description"
								onSave={onValueChange}
								dataKey="description"
								isRequired={true}
								initialValue={values.description}
								title="Description"
								type="text"
							/>
							<InputComponent
								placeholder="MEL / Other doc. reference"
								onSave={onValueChange}
								dataKey="reference"
								requiredRulesObjectType={OBJECT_TYPE_AIRCRAFT_DEFECT}
								initialValue={values.reference}
								title="MEL / Other doc. reference"
								type="text"
							/>
							<InputComponent
								placeholder="Tech log reference"
								onSave={onValueChange}
								dataKey="log_reference"
								requiredRulesObjectType={OBJECT_TYPE_AIRCRAFT_DEFECT}
								disabled={values.log_id}
								initialValue={values.log_reference}
								title="Tech log reference"
							/>
							{(getCustomFields(userSelf, OBJECT_TYPE_AIRCRAFT_DEFECT) || [])
								.map(field => (
									<CustomFieldInputItem
										key={field.key}
										model={values}
										field={field}
										onSave={onValueChange}
									/>
								))}
							<InputComponent
								placeholder="Additional info"
								onSave={onValueChange}
								dataKey="additional_info"
								requiredRulesObjectType={OBJECT_TYPE_AIRCRAFT_DEFECT}
								initialValue={values.additional_info}
								title="Addtitional info"
								type="text"
							/>
						</List>
						<List header="Reported">
							<InputComponent
								onSave={onValueChange}
								dataKey="date"
								type="date"
								title="Date"
								initialValue={values.date}
							/>
							{TRACKING_PARAMETERS.map(param => (
								isEnabledParameter(aircraft.enabled_parameters || [], param.key) && <InputComponent
									onSave={onValueChange}
									key={param.key}
									min={0}
									dataKey={`reported_${param.key}`}
									title={param.name}
									digits={param.precision}
									type={param.type === 'hours' ? 'hours' : 'number'}
									initialValue={values[`reported_${param.key}`] || 0}
								/>))}
						</List>
					</Overview>
				</ContentWrapper>
			</DefectWrapper>
		</Popup>
	);
}

export default DefectPopup;
